import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL_V2;

const initialState = {
  isLoading: false,
  error: null,
  products: [],
  product: null,
  page: 1,
  limit: 10,
  totalPages: 0,
  totalResults: 0,
};

const slice = createSlice({
  name: "catalogProduct",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },

    startProductLoading(state) {
      state.isLoading = true;
      state.error = null;
      state.product = null;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    finishLoading(state) {
      state.isLoading = false;
      state.error = null;
    },

    getProductsSuccess(state, action) {
      state.isLoading = false;
      state.products = action.payload.results || [];
      state.page = action.payload.page || 1;
      state.limit = action.payload.limit || 10;
      state.totalPages = action.payload.totalPages || 0;
      state.totalResults = action.payload.totalResults || 0;
    },

    getProductSuccess(state, action) {
      state.isLoading = false;
      state.product = action.payload.result || action.payload;
    },
  },
});

export default slice.reducer;

export function getCatalogProducts({ franchiseId, page = 1, limit = 10 }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/product`, {
        params: {
          franchiseId,
          page,
          limit,
        },
      });

      dispatch(slice.actions.getProductsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load catalog products."));
    }
  };
}

export function createCatalogProduct({ franchiseId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`${backendUrl}/franchise/product`, payload, {
        params: { franchiseId },
        headers: { "Content-Type": "multipart/form-data" },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to create catalog product.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}

export function getCatalogProduct({ franchiseId, productId }) {
  return async (dispatch) => {
    dispatch(slice.actions.startProductLoading());
    try {
      const response = await axios.get(`${backendUrl}/franchise/product/${productId}`, {
        params: { franchiseId },
      });

      dispatch(slice.actions.getProductSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error?.message || "Unable to load catalog product."));
    }
  };
}

export function updateCatalogProduct({ franchiseId, productId, payload }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`${backendUrl}/franchise/product/${productId}`, payload, {
        params: { franchiseId },
        headers: { "Content-Type": "multipart/form-data" },
      });

      dispatch(slice.actions.finishLoading());
      return response.data;
    } catch (error) {
      const message = error?.message || "Unable to update catalog product.";
      dispatch(slice.actions.hasError(message));
      throw error;
    }
  };
}
